export class Perfil {
  constructor({
    id = null,
    nome = null,
    grupos = Array(),
  }) {
    this.id = id;
    this.nome = nome;
    this.grupos = grupos;
  }
  static Build() {
    return new Perfil({
      id: null,
      nome: null,
      grupos: Array(),
    });
  }
  format() {
    this.grupos = this.grupos.map((p) => p.id);
    return this;
  }
}
